import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {
  getRelationTypeDisplay,
  PendingCustomerRelationAction,
  PendingCustomerRelationRequestView
} from '../../../../../../../models/customer';
import { AccountService } from '../../../../../../../services/account/account.service';
import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';
import { CustomerService } from '../../../../../../../services/customer/customer.service';
import { InboxService } from '../../../../../../../services/inbox/inbox.service';

@Component({
  selector: 'app-review-pending-linked-account-modal',
  templateUrl: './review-pending-linked-account-modal.component.html',
  styleUrls: ['./review-pending-linked-account-modal.component.css']
})
export class ReviewPendingLinkedAccountModalComponent implements OnInit {

  @Input() relationRequest: PendingCustomerRelationRequestView;
  @Input() showHideOption: boolean;
  @Input() savedCallback: () => undefined;

  public selectedAction: PendingCustomerRelationAction = null;

  public loadingReviewSubmit = false;
  public errorMessage = '';

  public serverError: number = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public getRelationTypeDisplay = getRelationTypeDisplay;
  public PendingCustomerRelationAction = PendingCustomerRelationAction;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService,
    private customerService: CustomerService,
    private inboxService: InboxService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }
  }

  /**
   * Whether a valid input has been selected. Used to determine whether the
   * save button is clickable.
   */
  public validInputSelected() {
    return (
      [
        PendingCustomerRelationAction.approve,
        PendingCustomerRelationAction.deny,
        PendingCustomerRelationAction.hide
      ].indexOf(this.selectedAction) >= 0
    );
  }

  public handleSave() {
    this.loadingReviewSubmit = true;

    this.errorMessage = '';

    if (!this.validInputSelected()) {
      this.errorMessage = 'Please choose a valid option.';
      this.loadingReviewSubmit = false;
      return;
    }

    this.customerService
      .managePendingCustomerRelation(
        this.relationRequest.id,
        this.selectedAction
      )
      .then(() => {
        this.inboxService.loadInboxCounts(true).then();
        this.savedCallback();
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to review customer links.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => {
        this.loadingReviewSubmit = false;
      });
  }

}
